import {Routes} from '@angular/router';
import cvDownloadPageRoutes from './download/cv-download-page.routing';

/**
 * Created by Rodrigo Quesada on 16/03/17.
 */
const routes: Routes = [{
    path: 'cv',
    children: (<Routes>[
        {path: '', redirectTo: 'download', pathMatch: 'full'}
    ]).concat(
        cvDownloadPageRoutes
    ),
    data: {impersonationAllowed: true}
}];
export default routes;



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/cv/cv-pages.routing.ts